module.exports = __webpack_public_path__ + "img/tb-4.2feba61b.png";